import { HololinkError } from "./base.exception";
export class DataError extends HololinkError {
    constructor(...args) {
        super(...args);
        this.userMessage = 'Some malformed data is happening, propaly not a valid Hololink';
        this.logMessage = 'Some malformed data is happening, propaly not a valid Hololink';
        Error.captureStackTrace(this, DataError);
    }
}
